import { Box, Container, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import CustomButton from '../../../../../Components/CustomButton/CustomButton'

import { makeGetRequest, makePostRequest } from '../../../../../utils/api'
import urls from '../../../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import EditOperationForm from './EditOperationForm'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
export const Instructions = ({ recette }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)

  useEffect(() => {
    fetchOperations()
  }, [])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudInstructionOperations}?Recette=${recette.id}`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      // let op = []
      // response.data.results.filter((v, index) => {
      //   op.push({ ...v, order_no: index + 1 })
      //   return ''
      // })

      // setOperations({
      //   ...response.data,
      //   results: op,
      // })
      setLoading(false)
    }
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkInstruction,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box display="flex" justifyContent={'flex-end'}>
          {isMobile ? (
            <Box display={'flex'} gap={2} color={'white'}>
              <CreateOperationForm recette={recette} fetchOperations={fetchOperations} />
              <RemoveCircleIcon onClick={deleteBulkOperations} />
              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    alert('Please Select one instruction for modifier')
                  }
                }}
              />
            </Box>
          ) : (
            <Box>
              <CreateOperationForm recette={recette} fetchOperations={fetchOperations} />
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    alert('Please Select one instruction for modifier')
                  }
                }}
              >
                Modifier
              </CustomButton>

              <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
            </Box>
          )}
        </Box>
        {selected ? (
          <EditOperationForm
            setSelected={setSelected}
            params={selectedRowsParams}
            fetchOperations={fetchOperations}
          />
        ) : (
          ''
        )}
        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
